import {
  Badge,
  Button,
  Flex,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { MdLocalLaundryService } from "react-icons/md";
import { Appliance } from "../../data/laundrette.api";

type Props = {
  appliance: Appliance;
};

const LaundryMachine = ({ appliance }: Props) => {
  const { onOpen, isOpen, onClose } = useDisclosure();
  const red = useColorModeValue("red.500", "red.400");
  const green = useColorModeValue("green.500", "green.300");

  const timeRemaining = useMemo(() => {
    const match = appliance.time_remaining.match(/(\d+)/);
    if (match) return match[1];
  }, [appliance]);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>
            {appliance.appliance_type === "W" ? "Washer" : "Dryer"}{" "}
            {appliance.label}
          </ModalHeader>
          <ModalBody>
            <Flex justify="space-between">
              <Stat>
                <StatLabel>Status</StatLabel>
                <StatNumber textTransform="capitalize">
                  {appliance.status.toLowerCase()}
                </StatNumber>
              </Stat>
              <Stat>
                <StatLabel>Time Remaining</StatLabel>
                <StatNumber>
                  {appliance.status === "IN USE"
                    ? `${timeRemaining} mins`
                    : "N/A"}
                </StatNumber>
              </Stat>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="lancsBlue" onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <IconButton
        variant="ghost"
        onClick={onOpen}
        icon={
          <Icon
            as={MdLocalLaundryService}
            color={appliance.status === "IN USE" ? red : green}
            w={10}
            h={10}
          />
        }
        aria-label="View laundry machine status"
      ></IconButton>
    </>
  );
};

export default LaundryMachine;
